export const AUTH_CALLBACK_URL = {
  mobile: "caloriegrid://auth/callback",
  web: "/auth/callback",
} as const;
